import { createPageApp } from '@/lib/createPageApp'
import BaseSeminarInfoPage from './BaseSeminarInfoPage.vue'

createPageApp(BaseSeminarInfoPage).mount()
